import { FallbackProps } from "react-error-boundary";
import NotFoundError from "../pages/error/NotFoundError";

function fallbackRender({ error}: FallbackProps) {
 return (<NotFoundError />); 
}
export default fallbackRender;